var map = {
	"./en/common": [
		464,
		464
	],
	"./en/common.json": [
		464,
		464
	],
	"./en/home": [
		2482,
		482
	],
	"./en/home.json": [
		2482,
		482
	],
	"./fr/common": [
		5167,
		167
	],
	"./fr/common.json": [
		5167,
		167
	],
	"./fr/home": [
		1660,
		660
	],
	"./fr/home.json": [
		1660,
		660
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 242;
module.exports = webpackAsyncContext;